import {Component, EventEmitter, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FilterBlock} from "./filter-block";
import {Filter} from "./filter-item/filter";
import {FilterSort} from "../../../../config/filters/filter-sort.enum";
import {SortService} from '../../../../shared/sort.service';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-filter-block',
  templateUrl: './filter-block.component.html',
  styleUrls: ['./filter-block.component.css']
})
export class FilterBlockComponent implements OnInit {

  @Input() filterBlock: FilterBlock;

  @Input() refreshFilterEmitter: EventEmitter<boolean>;

  @Input() blockId: string;

  browseMode: boolean =true;

  constructor(private sortService: SortService, private activeRoute: ActivatedRoute) {
    this.activeRoute.url.subscribe((qMap) => {
      let url = qMap.join('/');
      this.browseMode = url.search("search/b") >= 0;
    })
  }

  ngOnInit(): void {
    this.sort();
    this.filterBlock.childFilterBlocks.forEach(childFilterBlock => childFilterBlock.filters.sort((filterA, filterB) => this.pickSortFunction(filterA, filterB)));
    if (this.refreshFilterEmitter) {
      this.refreshFilterEmitter.subscribe(value => {
        this.sort();
      });
    }
  }

  private sort() {
    this.filterBlock.filters.sort((filterA, filterB) => this.pickSortFunction(filterA, filterB));
    this.filterBlock.childFilterBlocks.forEach(childFilterBlock => childFilterBlock.filters.sort((filterA, filterB) => this.pickSortFunction(filterA, filterB)));
  }

  private pickSortFunction(filterA: Filter, filterB: Filter) {
    if (filterA.selected === filterB.selected) {
      switch (this.filterBlock.filterConfig.sort) {
        case FilterSort.ALPHABETICAL:
          return this.sortService.sortSelectedThenAlphaFirst(filterA, filterB);
        default:
          return this.sortService.sortSelectedThenFreqFirst(filterA, filterB);
      }
    } else {
      return filterA.selected ? -1 : 1;
    }
  }


}
